var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReportExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Report_Exam",
    width: 24,
    height: 24,
    "data-name": "Icon - Report Exam",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6155",
    "data-name": "Group 6155",
    transform: "translate(-910 -1725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2655",
    fill: "none",
    d: "M0 0H24V24H0z",
    "data-name": "Rectangle 2655",
    transform: "translate(910 1725)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6157",
    "data-name": "Group 6157",
    transform: "translate(-987 -1572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2665",
    fill: "#32af50",
    d: "M8 0a8 8 0 0 1 8 8H0a8 8 0 0 1 8-8z",
    "data-name": "Rectangle 2665",
    transform: "rotate(180 503.5 796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2658",
    fill: "#f6c102",
    d: "M0 0a8 8 0 0 1 8 8H0V0z",
    "data-name": "Rectangle 2658",
    transform: "translate(1001 1574)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_2660",
    fill: "#b8e986",
    d: "M0 0h8a8 8 0 0 1-8 8V0z",
    "data-name": "Rectangle 2660",
    transform: "rotate(180 499.5 792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Subtraction_3",
    fill: "#21763b",
    d: "M5.655 8A7.947 7.947 0 0 1 .006 5.661L5.653.015 5.655 8z",
    "data-name": "Subtraction 3",
    transform: "rotate(-90 1294.328 295.328)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportExam);
export default __webpack_public_path__ + "static/media/icon-report-exam.f3a529a1af03c5d22e00135849e89a13.svg";
export { ForwardRef as ReactComponent };